module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "el-radio"
  }, [_c('span', {
    staticClass: "el-radio-input"
  }, [_c('span', {
    staticClass: "el-radio-inner",
    class: {
      'is-disabled': _vm.disabled,
      'is-checked': _vm.store === _vm.label,
        'is-focus': _vm.focus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.store),
      expression: "store"
    }],
    staticClass: "el-radio-original",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.store, _vm.label)
    },
    on: {
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      },
      "__c": function($event) {
        _vm.store = _vm.label
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "el-radio-label"
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eb44795!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/src/radio.vue
// module id = 645
// module chunks = 0